
import React from 'react'
import PropTypes from 'prop-types'
import Spinner from './Spinner';
import ErrorCard from './ErrorCard';
import StyledButton from 'shared-resources/components/src/StyledButton';

// deals with fetch info supplied by query hooks and displays loading and error states if applicable.
// only renders children when the fetch is done.
const WaitOn = ({
  fallback = (<Spinner />)
  , query
  , children
  , empty
  , error
}) => {

  const {
    isError: fetchError
    , error: fetchErrorMessage = "Oops, there was an error."
    , isLoading
    // , isFetching
    , isEmpty
    , refetch
  } = query;

  try {
    if (!query) return null;
    // there was an error fetching data
    // updated error, can now be a function that takes the error message as an argument
    if (fetchError) {
      if (typeof error === 'function') {
        return error(fetchErrorMessage);
      }
      return error || (
        <div className='h-full w-full flex items-center justify-center px-10'>
          <ErrorCard
            title="Something went wrong"
            message={fetchErrorMessage}
            actionComponent={() => (
              <StyledButton
                onClick={refetch}
                variant='primary'
                size="sm"
                text='Try again'
              />
            )}
          />
        </div>
      )
    }
    // still waiting for data
    if (isLoading) return fallback;
    // fetch returned empty
    if (isEmpty) return empty || <div className="p-8 whitespace-nowrap"><p className="text-gray-500 italic text-center block">No data found</p></div>
   
    return children || null;
  } catch (childError) {
    // debugging
    // console.log('Error in WaitOn children ', childError);
    // there was an error thrown by the children, but the app will not crash, it will display an error message instead.
    // Could somehow log this error or save it as a userEvent kind of thing. Could make it easier to track bugs over time.
    return (
      <ErrorCard
        title="Something went wrong"
        message="There was an error displaying the data."
        // actionComponent={() => <button className='btn-xs btn-warn' onClick={window.location.reload}>Try again</button>}
        actionComponent={() => (
          <StyledButton
            onClick={window.location.reload}
            variant="muted"
            size="sm"
          >
            Try again
          </StyledButton>
        )}
      />
    )
  }
}

WaitOn.propTypes = {
  fallback: PropTypes.node
  , query: PropTypes.object
  , children: PropTypes.node
  , empty: PropTypes.node
  , error: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
}

export default WaitOn;
